import { BaseComponent } from 'components/BaseComponent';
import { SvgIcon } from 'components/SvgIcon';
import Dialog from '@material-ui/core/Dialog';
import ExpansionPanel from '@material-ui/core/ExpansionPanel/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import Slide from '@material-ui/core/Slide';
import React from 'react';
import { paymentService } from 'services/PaymentService';
import { WithStyles } from 'shared/decorators/withStyles';

function Transition(props: any) {
  return <Slide direction="up" {...props} />;
}

const icon = (
  <span
    style={{
      borderTop: '5px solid #5A2254',
      borderLeft: '5px solid transparent',
      borderRight: '5px solid transparent',
      borderBottom: '5px solid transparent'
    }}
  />
);

@WithStyles(() => ({
  component: {
    '& span': {
      '&.chk-icon': {
        borderTop: '5px solid #000',
        borderLeft: '5px solid transparent',
        borderRight: '5px solid transparent',
        borderBottom: '5px solid transparent'
      }
    },

    '& .chk-header': {
      position: 'relative',
      height: '7rem',
      backgroundColor: '#596375'
    },

    '& .chk-title': {
      alignItems: 'center',
      display: 'flex',
      padding: '0 14px 0 24px',
      margin: '40px 0 40px 0',
      width: '100%',

      '@media screen and (max-width: 640px)': {
        display: 'flex'
      },

      '& .chk-close': {
        display: 'flex',
        backgroundColor: '#cecece',
        height: '25px',
        margin: '0 0 0 5px',
        width: '25px',
        borderRadius: '50px',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',

        '&:hover': {
          backgroundColor: '#b3b3b3'
        },

        '& svg': {
          width: '9px'
        }
      }
    },

    '& .chk-span-icon': {
      alignItems: 'center',
      display: 'flex',
      width: '100%',

      '& span': {
        color: '#596375',
        fontSize: '1.3rem',
        fontWeight: 700,
        margin: '3%'
      },

      '& svg': {
        fill: '#F59211',
        width: '1.5rem'
      }
    },

    '& .chk-expansion-panel': {
      margin: 0,
      border: 0,
      boxShadow: 'none',
      width: '100%',
      display: 'block',

      '&::before': {
        position: 'relative'
      },

      '& .chk-expansion-panel-detail': {
        display: 'flex',
        flexDirection: 'column',
        boxShadow: 'inset 0 0 100px 1px rgba(0, 0, 0, .1)',

        '& .sub-title': {
          margin: '0 0 0 25px',
          fontSize: '0.975rem'
        },

        '& p': {
          color: 'rgba(89, 99, 117, 1)',
          textAlign: 'justify'
        },

        '& ul': {
          color: 'rgba(89, 99, 117, 1)',
          textAlign: 'justify',
          padding: '0 0 0 24px',

          '& li': {
            fontSize: '0.875rem'
          }
        }
      },

      '& .chk-expansion-title': {
        color: '#596375',
        fontSize: '1rem'
      }
    },

    '& .chk-central-help': {
      '& .producer-contact': {
        marginBottom: '30px'
      },

      fontSize: '1rem',
      textAlign: 'center',
      lineHeight: 0.5,
      marginTop: '20%',

      '@media screen and (max-width: 640px)': {
        marginTop: '5%'
      },

      '& p': {
        color: '#596375'
      }
    }
  }
}))
export default class Faq extends BaseComponent<any> {
  constructor(props: any) {
    super(props);
    this.state = { open: false };
  }

  componentDidMount() {
    this.observeState({ paymentResult: null }, paymentService.getPaymentResult());
  }

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  openHelp = () => {
    window.open('https://ajuda.eduzz.com/?article=como-reimprimir-o-boleto-ou-mudar-o-metodo-de-pagamento');
  };

  openHelp2 = () => {
    window.open('https://ajuda.eduzz.com/?article=1167');
  };
  openHelp3 = () => {
    window.open('https://ajuda.eduzz.com/?article-category=clientes');
  };

  render() {
    return (
      <div className={'chk-modal-doubts'}>
        {this.props.showIcon ? <SvgIcon name="chatIcon" /> : ''}{' '}
        <a id="exitpoup-close" href="#" onClick={this.handleClickOpen}>
          {this.props.name}
        </a>
        <Dialog
          className={this.props.classes.component}
          open={this.state.open}
          onClose={this.handleClose}
          TransitionComponent={Transition}
          transitionDuration={800}
        >
          <div className={'chk-title'}>
            <div className={'chk-span-icon'}>
              <SvgIcon name="chatIcon" />
              <span>Dúvidas Frequentes</span>
            </div>
            <div className="chk-close" color="inherit" onClick={this.handleClose} aria-label="Close">
              <SvgIcon name="closeIcon" />
            </div>
          </div>
          <ExpansionPanel className={'chk-expansion-panel'}>
            <ExpansionPanelSummary expandIcon={icon}>
              <p className={'chk-expansion-title zlabel'}>Como Receberei meu produto/conteúdo?</p>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails className={'chk-expansion-panel-detail '}>
              <p>
                Através da Eduzz , você receberá e-mails de recibo de pagamento,links de acesso ao produto. Nesses
                e-mails contém informações e dados de acesso ou link para download do conteúdo adquirido, também
                Informações importantes, como dados do Produtor responsável pelo conteúdo.
              </p>
            </ExpansionPanelDetails>
          </ExpansionPanel>
          <ExpansionPanel className={'chk-expansion-panel'}>
            <ExpansionPanelSummary expandIcon={icon}>
              <p className={'chk-expansion-title zlabel'}>O que são produtos digitais? Quais as vantagens?</p>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails className={'chk-expansion-panel-detail '}>
              <div>
                <li>Pode ser acessado de qualquer lugar:</li>
                <p>
                  Produtos digitais podem ser acessados em qualquer lugar do planeta, basta possuir um dispositivo capaz
                  de processar e visualizar o conteúdo, por exemplo um smartphone, computador ou tablet.
                </p>
                <li>O Prazo de entrega:</li>
                <p>
                  Assim que o pagamento é confirmado, o Infoproduto é enviado instantaneamente ao seu e-mail. Você não
                  precisa se preocupar com longos prazos de espera para desfrutar do conteúdo.
                </p>
                <li>Dispensa o espaço físico:</li>
                <p>
                  Produtos digitais podem ser armazenados em computadores, smartphones ou até mesmo em sites
                  especializados em armazenamento de informações em “nuvem”, como o Google Drive e o Dropbox.
                </p>
              </div>
            </ExpansionPanelDetails>
          </ExpansionPanel>
          <ExpansionPanel className={'chk-expansion-panel'}>
            <ExpansionPanelSummary expandIcon={icon}>
              <p className={'chk-expansion-title zlabel'}>Como Reimprimir o boleto ou mudar o método de pagamento?</p>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails className={'chk-expansion-panel-detail '}>
              <div>
                <p>
                  Todas as compras são intermediadas pela Eduzz. Você deverá acessar o site para poder reimprimir ou
                  mudar a forma de pagamento. Para saber mais click
                </p>
                <a onClick={this.openHelp} href="#">
                  AQUI.
                </a>
              </div>
            </ExpansionPanelDetails>
          </ExpansionPanel>
          <ExpansionPanel className={'chk-expansion-panel'}>
            <ExpansionPanelSummary expandIcon={icon}>
              <p className={'chk-expansion-title zlabel'}>Como visualizar meu código de rastreio?</p>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails className={'chk-expansion-panel-detail '}>
              <p>
                Após o seu produto ser enviado pelo Produtor, ele irá inserir o código de rastreio na Eduzz. Para
                visualizar e acompanhar a sua compra, é preciso que acesse a sua conta. Saiba como clicando{' '}
                <a onClick={this.openHelp2} href="#">
                  {' '}
                  AQUI.
                </a>
              </p>
            </ExpansionPanelDetails>
          </ExpansionPanel>
          <div className={'chk-central-help'}>
            {this.props.showProducerContact ? (
              <div className="producer-contact">
                Dúvidas sobre o produto adquirido entre em contato com o produtor:
                <p>{this.props.infos.producerName}</p>
                <p>{this.props.infos.producerEmail}</p>
              </div>
            ) : null}
            <p>Não achou o que precisa?</p>
            <p>
              Acesse nossa{' '}
              <a onClick={this.openHelp3} href="#">
                Central de Ajuda
              </a>
            </p>
          </div>
        </Dialog>
      </div>
    );
  }
}
